<div class="generic-modal">
  <p-dialog
    #modalContainer
    [(visible)]="modalContainer.display"
    modal="modal"
    [header]="modalContainer.header"
    [showHeader]="modalContainer.showHeader"
    [resizable]="false"
    [style]="{ 'max-width': maxWidth + 'px' }"
    [closable]="modalContainer.closable"
    [closeOnEscape]="modalContainer.closeOnEscape"
    [position]="'top'"
    [draggable]="false"
    (onHide)="onHide()"
  >
    <ng-template #dynamicContent></ng-template>

    @if (defaultButtons) {
      <div class="modal-footer">
        @if (cancelButton) {
          <button type="button" class="btn" (click)="reject()">Cancel</button>
        }

        @if (acceptButton) {
          <button type="button" class="btn btn-primary" (click)="accept()">Accept</button>
        }
      </div>
    }
  </p-dialog>
</div>
